<script lang="ts">

import { SecurityAlert } from '../models/state';
import { alertsSeedData } from '../models/seed';
import { securityStats } from '../models/constants';

	// Mock data
	const alerts: SecurityAlert[] = [ ...alertsSeedData];

	

	let selectedCategory = $state<string>('all');

	const getSeverityColor = (severity: string) => {
		switch (severity) {
			case 'critical':
				return 'text-red-600 bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800';
			case 'high':
				return 'text-orange-600 bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800';
			case 'medium':
				return 'text-yellow-600 bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800';
			case 'low':
				return 'text-blue-600 bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800';
			default:
				return 'text-gray-600 bg-gray-50 dark:bg-gray-900/20 border-gray-200 dark:border-gray-800';
		}
	};

	const getTypeIcon = (type: string) => {
		switch (type) {
			case 'vulnerability':
				return `<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>`;
			case 'secret':
				return `<path fill-rule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clip-rule="evenodd"/>`;
			case 'code-scanning':
				return `<path fill-rule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"/>`;
			default:
				return '';
		}
	};
</script>

<div class="space-y-6">
	<!-- Security Overview Cards -->
	<div class="grid grid-cols-1 md:grid-cols-4 gap-4">
		<div
			class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-shadow cursor-pointer"
			onclick={() => (selectedCategory = 'all')}
		>
			<div class="flex items-center justify-between">
				<div>
					<p class="text-sm text-gray-600 dark:text-gray-400">Total Alerts</p>
					<p class="text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">
						{securityStats.total}
					</p>
				</div>
				<svg class="w-10 h-10 text-orange-500" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
						clip-rule="evenodd"
					/>
				</svg>
			</div>
		</div>

		<div
			class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-shadow cursor-pointer"
			onclick={() => (selectedCategory = 'vulnerability')}
		>
			<div class="flex items-center justify-between">
				<div>
					<p class="text-sm text-gray-600 dark:text-gray-400">Vulnerabilities</p>
					<p class="text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">
						{securityStats.vulnerabilities}
					</p>
				</div>
				<svg class="w-10 h-10 text-red-500" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
						clip-rule="evenodd"
					/>
				</svg>
			</div>
		</div>

		<div
			class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-shadow cursor-pointer"
			onclick={() => (selectedCategory = 'secret')}
		>
			<div class="flex items-center justify-between">
				<div>
					<p class="text-sm text-gray-600 dark:text-gray-400">Secret Scanning</p>
					<p class="text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">
						{securityStats.secrets}
					</p>
				</div>
				<svg class="w-10 h-10 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z"
						clip-rule="evenodd"
					/>
				</svg>
			</div>
		</div>

		<div
			class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-shadow cursor-pointer"
			onclick={() => (selectedCategory = 'code-scanning')}
		>
			<div class="flex items-center justify-between">
				<div>
					<p class="text-sm text-gray-600 dark:text-gray-400">Code Scanning</p>
					<p class="text-3xl font-bold text-gray-900 dark:text-gray-100 mt-1">
						{securityStats.codeScanning}
					</p>
				</div>
				<svg class="w-10 h-10 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/>
				</svg>
			</div>
		</div>
	</div>

	<!-- Alerts List -->
	<div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
		<div class="p-4 border-b border-gray-200 dark:border-gray-700">
			<div class="flex items-center justify-between">
				<h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Security Alerts</h2>
				<div class="flex items-center gap-2">
					<button
						class="px-3 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
					>
						Filter
					</button>
					<button
						class="px-3 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
					>
						Sort
					</button>
				</div>
			</div>
		</div>

		<div class="divide-y divide-gray-200 dark:divide-gray-700">
			{#each alerts.filter((a) => selectedCategory === 'all' || a.type === selectedCategory) as alert}
				<div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-750 transition-colors">
					<div class="flex items-start gap-4">
						<div class="mt-1">
							<svg class="w-6 h-6 text-gray-600 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20">
								{@html getTypeIcon(alert.type)}
							</svg>
						</div>
						<div class="flex-1 min-w-0">
							<div class="flex items-start justify-between gap-4">
								<div class="flex-1">
									<h3 class="text-gray-900 dark:text-gray-100 font-medium">{alert.title}</h3>
									<p class="text-sm text-gray-600 dark:text-gray-400 mt-1">{alert.description}</p>
									{#if alert.affectedPackage}
										<p class="text-sm text-gray-500 dark:text-gray-500 mt-2">
											Affected: <code
												class="px-2 py-0.5 bg-gray-100 dark:bg-gray-900 rounded text-xs"
												>{alert.affectedPackage}</code
											>
										</p>
									{/if}
									<div class="flex items-center gap-3 mt-3 text-xs text-gray-600 dark:text-gray-400">
										<span>Detected {alert.createdAt}</span>
										<span
											class="px-2 py-0.5 rounded-full font-medium capitalize {alert.status === 'open'
												? 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400'
												: alert.status === 'fixed'
													? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400'
													: 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400'}"
										>
											{alert.status}
										</span>
									</div>
								</div>
								<div class="flex flex-col items-end gap-2">
									<span
										class="px-3 py-1 rounded-full text-xs font-semibold border uppercase {getSeverityColor(
											alert.severity
										)}"
									>
										{alert.severity}
									</span>
									{#if alert.status === 'open'}
										<button
											class="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
										>
											Dismiss
										</button>
									{/if}
								</div>
							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>

		<!-- Empty State -->
		{#if alerts.filter((a) => selectedCategory === 'all' || a.type === selectedCategory).length === 0}
			<div class="p-12 text-center">
				<svg class="w-16 h-16 mx-auto text-green-500 mb-4" fill="currentColor" viewBox="0 0 20 20">
					<path
						fill-rule="evenodd"
						d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
						clip-rule="evenodd"
					/>
				</svg>
				<h3 class="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">All clear!</h3>
				<p class="text-gray-600 dark:text-gray-400">No security alerts found in this category.</p>
			</div>
		{/if}
	</div>
</div>
